(function (root, factory) {
    const pluginName = 'ShowMore';

    // eslint-disable-next-line no-undef
    if (typeof define === 'function' && define.amd) {
        // eslint-disable-next-line no-undef
        define([], factory(pluginName));
    } else if (typeof exports === 'object') {
        module.exports = factory(pluginName);
    } else {
        root[pluginName] = factory(pluginName);
    }
// eslint-disable-next-line no-unused-vars
}(this, (pluginName) => {
    const config = {
        expander: '.c-show-more',
        expanderBtn: '.c-show-more button',
        minHeightText: window.matchMedia('(max-width: 767px)').matches ? 230 : 200,
        call: false,
        blockLabelShow: 'Show the rest of the text describing this product',
        blockLabelHide: 'Hide content that was previously shown',
    };

    const trigger = function () {
        const tab = document.querySelector('.current-tab-content');
        if (!tab) {
            return;
        }

        const expanderComp = tab.querySelector(config.expander);
        if (!expanderComp) {
            return;
        }

        const container = tab.querySelector(config.expander).previousElementSibling;
        if (!container) {
            return;
        }

        if (container.offsetHeight < config.minHeightText && !tab.querySelector('.hiddenContent')) {
            tab.querySelector('.c-show-more').style.display = 'none';
            return;
        }

        if (container.offsetHeight > config.minHeightText) {
            if (!tab.querySelector('.hiddenContent')) {
                let top = 0;
                let visibleContent = '';
                let hiddenContent = '';
                let tabContent;

                if (container.children.length < 2) {
                    tabContent = container.firstElementChild;
                } else {
                    tabContent = container;
                }
                
                tabContent.classList.add('visibleContent');
                tabContent.setAttribute(
                    'style',
                    `height: ${config.minHeightText}px; overflow: hidden; position: relative;`,
                );

                const tabContentChild = tabContent.childNodes;
                const height = tabContent.offsetHeight;
                for (let i = 0; i < tabContentChild.length; i += 1) {
                    if (tabContentChild[i].offsetTop) {
                        top = tabContentChild[i].offsetTop;
                    }

                    if (tabContentChild[i].nodeType === Node.TEXT_NODE) {
                        if (top < height) {
                            visibleContent += tabContentChild[i].textContent;
                        } else {
                            hiddenContent += tabContentChild[i].textContent;
                        }
                    } else if (top < height) {
                        visibleContent += tabContentChild[i].outerHTML;
                    } else {
                        hiddenContent += tabContentChild[i].outerHTML;
                    }
                }

                tabContent.insertAdjacentHTML('afterend', '<div class="hiddenContent"></div>');
                tabContent.innerHTML = visibleContent;
                tab.querySelector('.hiddenContent').innerHTML = hiddenContent;
            }
        }
        const hiddenBlock = tab.querySelector('.hiddenContent');
        const showButton = tab.querySelector(config.expanderBtn);
        const blockId = 'hiddenBlock';
        hiddenBlock.setAttribute('id', blockId);
        hiddenBlock.setAttribute('tabindex', '-1');
        showButton.setAttribute('aria-controls', blockId);
    };

    const addListener = function () {
        const showMore = document.querySelectorAll(config.expanderBtn);
        if (!showMore.length) {
            return;
        }

        showMore.forEach((item) => {
            /* Disabled due to ticket requirements - PMCCP-67262 */
            // item.setAttribute('aria-label', config.blockLabelShow);

            item.addEventListener('click', (e) => {
                e.preventDefault();
                const expander = e.currentTarget;
                const container = expander.closest('.current-tab-content');
                const visibleContent = container.querySelector('.visibleContent');
                const hiddenContent = container.querySelector('.hiddenContent');

                if (expander.getAttribute('aria-expanded') === 'true') {
                    expander.setAttribute('aria-expanded', 'false');
                    expander.closest('.c-show-more').classList.add('collapsed');
                    expander.firstChild.innerHTML = 'Show more';

                    $('html, body').scrollTop(expander.closest('.c-tabs-wrapper').getBoundingClientRect().top
                        + window.scrollY);

                    // eslint-disable-next-line max-len
                    visibleContent.setAttribute('style', `height: ${config.minHeightText}px; overflow: hidden; position: relative;`);
                    hiddenContent.style.display = 'none';
                } else {
                    expander.setAttribute('aria-expanded', 'true');
                    expander.closest('.c-show-more').classList.remove('collapsed');
                    expander.firstChild.innerHTML = 'Show less';

                    $('html, body').animate({
                        scrollTop: expander.closest('.c-tabs-wrapper').getBoundingClientRect().top + window.scrollY,
                    }, 300);

                    visibleContent.removeAttribute('style');
                    hiddenContent.style.display = 'block';
                    hiddenContent.focus();
                    /* Disabled due to ticket requirements - PMCCP-67262 */
                    // container.querySelector(config.expanderBtn).setAttribute('aria-label', config.blockLabelHide);
                }
            });
        });
    };

    /**
     * Plugin Object
     * @constructor
     */
    function Plugin() {
        // Initialize show more component
        this.init();
    }

    /**
     * Plugin prototype
     * @public
     * @constructor
     */
    Plugin.prototype = {
        init() {
            addListener();
            trigger();
        },
        trigger,
    };

    return Plugin;
}));
